import React, {useEffect, useState} from 'react';
import '@PikaDoApp/pikado-web-dsm/dist/dist/styles.css';

import '@fontsource/roboto';
import './index.css';
//@ts-ignore
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';

import {withAuthenticator} from '@aws-amplify/ui-react';
import {Amplify} from 'aws-amplify';
import awsconfig from './aws-exports';
import {PersistGate} from 'redux-persist/es/integration/react';

import {Layout} from 'antd';
import {persistor, store} from './redux/store';

import {Provider, useDispatch} from 'react-redux';
import {Routers} from './router/Routers';
import {NewStudentReportService} from './modules/Report/StudentReport/NewStudentReportService';
import {initializePikadoClient} from './lib/initializePikadoClient';
const {Content, Footer} = Layout;

Amplify.configure(awsconfig);

// Initialize npm-pikado-logic AFTER Amplify is configured
// Pass both Amplify instance and raw config for v6 compatibility
NewStudentReportService.initialize(awsconfig);
initializePikadoClient();

function App() {
  return (
    <div style={{height: '100%'}}>
      <BrowserRouter>
        {/* @ts-ignore */}
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Layout>
              <Content>
                <Routes>
                  <Route path="/*" element={<Routers />} />
                </Routes>
              </Content>
            </Layout>
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
